import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "MaintenanceDutyListPage" */
	'pages/vehicle/MaintenanceDuty/MaintenanceDutyListPage'));

export default [{ component, exact: true, path: '/maintenance_duties' }];